import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Circle } from '@chakra-ui/react';
import { CheckIcon, ViewIcon } from '@src/components/sco/icons';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import React, { useEffect } from 'react';
type ListNavDotIndicatorProps = {
  isActive?: boolean;
  viewableType?: string;
  viewableId?: string;
};
export const ListNavDotIndicator = props => {
  const $ = _c(29);
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($viewableType: String, $viewableId: String) {
        scoView(viewableType: $viewableType, viewableId: $viewableId) {
          id
          viewableType
          viewableId
          startedAt
          completionAsPercent
          completedAt
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !currentUser?.isRegistered;
  let t2;
  if ($[1] !== props.viewableId || $[2] !== props.viewableType) {
    t2 = {
      viewableType: props.viewableType,
      viewableId: props.viewableId
    };
    $[1] = props.viewableId;
    $[2] = props.viewableType;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      ssr: false,
      skip: t1,
      variables: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const viewQuery = useQuery(t0, t3);
  let t4;
  if ($[7] !== currentUser?.isRegistered || $[8] !== props.viewableId || $[9] !== props.viewableType || $[10] !== viewQuery) {
    t4 = () => {
      if (!viewQuery.loading && props.viewableType && props.viewableId && currentUser?.isRegistered) {
        viewQuery.refetch({
          viewableType: props.viewableType,
          viewableId: props.viewableId
        });
      }
    };
    $[7] = currentUser?.isRegistered;
    $[8] = props.viewableId;
    $[9] = props.viewableType;
    $[10] = viewQuery;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props.isActive || $[13] !== props.viewableId || $[14] !== props.viewableType) {
    t5 = [props.isActive, props.viewableType, props.viewableId];
    $[12] = props.isActive;
    $[13] = props.viewableId;
    $[14] = props.viewableType;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  useEffect(t4, t5);
  const isCompleted = viewQuery.data?.scoView?.completedAt || viewQuery.data?.scoView?.completedAt >= 100;
  const isStarted = !!viewQuery.data?.scoView?.startedAt && !isCompleted;
  if (isCompleted) {
    const t6 = isCompleted ? "bg.success" : "whiteAlpha.500";
    const t7 = props.isActive ? "transparent" : "whiteAlpha.500";
    let t8;
    if ($[16] !== isCompleted) {
      t8 = isCompleted && <CheckIcon color="#181727" marginTop="0.05em" opacity={1} width="0.5em" />;
      $[16] = isCompleted;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
      t9 = <Circle bgColor={t6} borderColor={t7} size="1.2em">{t8}</Circle>;
      $[18] = t6;
      $[19] = t7;
      $[20] = t8;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    return t9;
  }
  const t6 = props.isActive ? "colorPalette.border" : "transparent";
  const t7 = props.isActive ? "colorPalette.border" : "colorPalette.fg/50";
  let t8;
  if ($[22] !== isStarted || $[23] !== props.isActive) {
    t8 = isStarted && <ViewIcon color={props.isActive ? "colorPalette.fg" : "colorPalette.fg/50"} marginTop="0.05em" width="0.5em" />;
    $[22] = isStarted;
    $[23] = props.isActive;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
    t9 = <Circle bgColor={t6} border="0.125em solid" borderColor={t7} size="1.2em">{t8}</Circle>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};